

// Modules
import * as THREE from "three"
import gsap from "gsap"

// HelpersThree
import Scene3dFXAA from '../Scene3dFXAA'
import Scene3d from '../Scene3d'
import Cylinder from '../Cylinder'
import Cylinder2 from '../Cylinder2'

// Helpers - Others
import MyEmitter from '../../MyEmitter'

// utils
import params from '../../../utils/params'
import utils from "../../../utils/utils"

// Constants

const ROTATION_Y_SPEED =  .0035
const ROTATION_EASE = .05
const ROTATION_LIMITER = 1.25

// Synced with Slider.ANIMATION_SLIDE_DURATION
const ANIMATION_SLIDE_DURATION = 1.3 // related to Slider.js

const CONSTANT_FOR_CYLINDER_REPEAT_AS_2 = .7
const CAMERA_TOP_POSITION = 3.6
const MUST_ROTATE_BACK_CYLINDER_OFFSET_TOO = true
const INITIAL_ROTATION_CYLINDER_ROTATION = Math.PI - (1 / 4) * Math.PI * 2 * CONSTANT_FOR_CYLINDER_REPEAT_AS_2

/** DEV */
const DEV_SKIP_ANIM = params.DEV_SKIP_ANIM


const LOGO_MODE = {
    header: "header",
    middle: "middle",
}

const scale_scene_by_window_height = utils.getLinearFunction(
    {x0: 790, y0: 1},
    {x1: 980, y1: .9},
)


const OPENING_ANIMATIONS_LABEL = {
    wordAppears: "wordAppears",
}

window.THREE = THREE

let sceneLogoClearColor = utils.isInstagram() ? "none" : utils.isSafari() ? null : new THREE.Color(1, 1, 1)
export default class SceneLogo extends Scene3dFXAA{
    constructor(container, parameters, data){
        super(container, {
            ...parameters,
            clearColor: sceneLogoClearColor,
            disableScene3dFXAA: utils.isInstagram()
        })

        console.log("SCENE LOG OON")

        window.SceneLogo = this

        this.data = data

        // parameters
        this._canRotate = DEV_SKIP_ANIM
        this._rafRotateCylinder = null

        // variables
        this._targetMouse = new THREE.Vector2()
        this._currentMouse = new THREE.Vector2()

        this._hasStarted = false

        this._logoMode = null
        this._animatingHover = false

        
        // unvariables
        this._origin = new THREE.Vector3()


        this._openingAnimationTimeline = null

        // bind
        this.onMouseMove = this.onMouseMove.bind(this)
        this.onSliderSlide = this.onSliderSlide.bind(this)
        this.handleLeave = this.handleLeave.bind(this)
        this.onRessourcesReady = this.onRessourcesReady.bind(this)
        this.onMobileOrientation = this.onMobileOrientation.bind(this)

        // Permanent event
        MyEmitter.on(params.Events.restartSceneLogo, () => this.start(false))

        // wait for ressources
        MyEmitter.once(params.Events.appHasLoadedRessources, this.onRessourcesReady)
    }

    /** Overrides */
    onWindowResize(...args){
        super.onWindowResize(...args)
        this.applyHeightWindowScale()
    }

    init(){
        super.init()
        this.applyHeightWindowScale()
    }

    /** Public */
    _onMouseEnterLogo(){

        /** Animate 180edgree rotatino on hover */
        if(this._logoMode === LOGO_MODE.header && !this._animatingHover){

            this._animatingHover = true

            gsap.fromTo([this._frontCylinder.material.map.offset, this._backCylinder.material.map.offset], {
                x: 1 - (1 / 4) - .02 // related to r01
            }, {
                duration: 1.2,
                ease: params.Animations.easeInOut,
                onComplete: () => {
                    this._animatingHover = false
                },
    
                x: 1 - (2 / 4) - .02 // related to r01
            })
        }
    }

    /** Helpers */

    applyHeightWindowScale(){

        // no auto scale in mobile mode
        if(this.data.isMobile) return

        let scale = scale_scene_by_window_height(window.innerHeight)
        this.scene.scale.setScalar(scale)
    }

    getModulo(angle){
        return Math.floor(angle / (2 * Math.PI))
    }

    initScene(){
        super.initScene()

        // set camera
        this.camera.position.setFromSphericalCoords(
            20,
            Math.PI * .5,
            Math.PI
        )

        // containers

        this._cylinderContainer = new THREE.Group()
        this.scene.add(this._cylinderContainer)
        this._cylinderContainer.scale.setScalar(1.15)

        this._tiltingContainer = new THREE.Group()
        this._cylinderContainer.add(this._tiltingContainer)

        // set containers
        this._rotatingContainer = new THREE.Group()
        // this._rotatingContainer.add(new THREE.AxesHelper(10))

        // rotate it so we can see the first word at the center
        this._rotatingContainer.rotation.y = INITIAL_ROTATION_CYLINDER_ROTATION
        this._tiltingContainer.add(this._rotatingContainer)

        // set cylinder
        let radius = 6.4
        let ratio = 43

        let cylinderCommonParameters = {
            repeat: 4,
            cylinderRadius: radius,
            radialSegments: 128,
            nearestPow2: false,
            quality: (window.devicePixelRatio || 1) + 1,
            // anisotropy: this.renderer.getMaxAnisotropy(),
            // minFilter: THREE.LinearMipmapLinearFilter
        }

        this._frontCylinder = new Cylinder2(
            [
                {text: "UBIQUITY", fontSize: 35, fontWeight: 700, fontFamily: "GrtskMegaBold"},
            ],
            {
                ...cylinderCommonParameters,
                side: THREE.FrontSide,

            }
        ).getMesh()

        // Set cylinder parameter for animating repeat (2<->4)
        this._cylinderGeometryPosition = this._frontCylinder.geometry.attributes.position
        this._initialCylinderGeometryPositionArray = [...this._cylinderGeometryPosition.array]
        this._cylinderGeometryPositionArrayLength = this._initialCylinderGeometryPositionArray.length
    
        this._backCylinder = new Cylinder2(
            [
                {text: "UBIQUITY", fontSize: 35, fontWeight: 200, fontFamily: "GrtskMegaExtralight"},
            ],
            {
                ...cylinderCommonParameters,
                reversed: true,
                side: THREE.BackSide,
            }
        ).getMesh()

        this._rotatingContainer.add(this._frontCylinder)
        this._rotatingContainer.add(this._backCylinder)

        // set meshes for loader animation
        if(!DEV_SKIP_ANIM){

            // set as repeat 2
            this._frontCylinder.material.map.repeat.x = this._backCylinder.material.map.repeat.x = CONSTANT_FOR_CYLINDER_REPEAT_AS_2
            this._frontCylinder.geometry.attributes.position.array = this._backCylinder.geometry.attributes.position.array = this._frontCylinder.geometry.attributes.position.array.map((p, i) => {
                
                if(i%3 ===0 || i%3 === 2){
                    return p * CONSTANT_FOR_CYLINDER_REPEAT_AS_2
                } else {
                    return p
                }
            })


            this._frontCylinder.material.map.offset.x = 1

            this._backCylinder.material.transparent = true
            this._backCylinder.material.opacity = 0

        } else {
            Array.from(this.data.navItems).map(m => {
                m.style.opacity = 1
                m.style.visibility = "visible"
            })
        }


        /** Fix mouse position for mobile */
        if(this.data.isMobile){
            this._targetMouse.set(0, -.1)
            this._cylinderContainer.scale.set(
                1.2,
                1.1,
                1.2
            )
        }


        // with the new cylinder we must scale down the cylinder container so it fit mockups
        this._cylinderContainer.scale.multiplyScalar(.85)
    }


    onRender(){
        this.camera.lookAt(this._origin)

        if(this._canRotate){

            // apply infinite rotation

            this._rotatingContainer.rotation.y += ROTATION_Y_SPEED

            // apply rotation from mouse move
            let tilting = utils.getRestrictedTiltingRotation(this._currentMouse, this._targetMouse, ROTATION_EASE)

            this._tiltingContainer.rotation.x = tilting.tiltingX * ROTATION_LIMITER
            this._tiltingContainer.rotation.z = tilting.titlingZ * ROTATION_LIMITER

            // tilt position to center with text
            this._tiltingContainer.position.y = -this._currentMouse.y * 1

            this._currentMouse.set(tilting.nextX, tilting.nextY)
        }
    }

    start(firstAnimate = true){
        super.start()

        this.container.style.opacity = 1

        if(firstAnimate){
            if(DEV_SKIP_ANIM){
                this.onLoaderEnd()
            } else {
                this.animateLogoAppear()
            }
        }


        MyEmitter.on(params.Events.onSliderSlide, this.onSliderSlide)

        this._hasStarted = true
    }

    stop(){
        super.stop()

        this.container.style.opacity = 0

        MyEmitter.off(params.Events.onSliderSlide, this.onSliderSlide)
        this._hasStarted = false

    }

    /** Animations */

    _animateToHeaderState(isMobile, onComplete){

        let duration = 1.2

        // stop events
        this._canRotate = false


        // start timeline
        let timeline = gsap.timeline({
            onComplete: () => {
                this._logoMode = LOGO_MODE.header
                onComplete && onComplete()
            }
        })

        // tilt
        timeline.to(this._tiltingContainer.rotation, {
            duration: duration,
            ease: params.Animations.easeDecrement,

            x: 0,
            z: 0
        })

        // restore position tilting
        timeline.to(this._tiltingContainer.position, {
            duration: duration,
            ease: params.Animations.easeDecrement,
            
            y: 0,
        }, 0)

        // restore scale
        timeline.to(this._tiltingContainer.scale, {
            duration: duration,
            ease: params.Animations.easeDecrement,
            
            x: 1,
            y: 1,
            z: 1,
        }, 0)
        
        let rotationYTarget = INITIAL_ROTATION_CYLINDER_ROTATION + Math.PI * 2 * this.getModulo(this._rotatingContainer.rotation.y)

        // infinite rotation
        timeline.to(this._rotatingContainer.rotation, {
            duration: duration,
            ease: params.Animations.easeDecrement,

            y: rotationYTarget
        }, 0)

        // texture offset
        timeline.to([this._frontCylinder.material.map.offset, this._backCylinder.material.map.offset], {
            duration: duration,
            ease: params.Animations.easeDecrement,

            x: 1 - (1 / 4) - .02 // related to r01
        }, 0)

        // repeat 4 -> 2
        timeline.add(this.fromRepeat4to2(duration), 0)

        // Mobile mode - fade logo
        if(this.data.isMobile){

            timeline.to(this.container, Object.assign({
                duration: duration,
                ease: params.Animations.easeDecrement,
    
                opacity: 0,
            }), "<")

        }
        

        
    }


    _animateToMiddleState(){
        this.animateLogoAppear(true)
    }

    fromRepeat4to2 = (duration) => {

        // geometry position
        let position = this._cylinderGeometryPosition
        let array = this._cylinderGeometryPosition.array
        let length = this._cylinderGeometryPositionArrayLength
        let prevPositionArray = [...array]

        // material repeat
        let initialRepeat = this._frontCylinder.material.map.repeat.x

        // camera
        let initialCameraPositionY = this.camera.position.y

        // back cylinder material
        let initialBackCylinderMaterialOpacity = this._backCylinder.material.opacity

        let animation = {$progress: 0}

        return gsap.to(animation, {
            duration: duration,
            ease: params.Animations.easeInOut,

            onUpdate: () => {

                let p = animation.$progress

                // animate geometry position
                for(let i = 0; i < length; i++){

                    if(i % 3 === 0 || i % 3 === 2 ){

                        let targetValue = prevPositionArray[i] * CONSTANT_FOR_CYLINDER_REPEAT_AS_2
                        let newValue = prevPositionArray[i] + (targetValue - prevPositionArray[i]) * p
                        array[i] = newValue
                        this._backCylinder.geometry.attributes.position.array[i] = newValue
                    }
                }

                position.needsUpdate = true
                this._backCylinder.geometry.attributes.position.needsUpdate = true

                // animate material repeat
                let newRepeat = initialRepeat + (CONSTANT_FOR_CYLINDER_REPEAT_AS_2 - initialRepeat) * p
               
                this._frontCylinder.material.map.repeat.x = newRepeat
                this._backCylinder.material.map.repeat.x = newRepeat
                
                // camera
                this.camera.position.y = initialCameraPositionY + (0 - initialCameraPositionY) * p

                /**
                 * animate back cylinder material
                 */
                this._backCylinder.material.opacity = initialBackCylinderMaterialOpacity + (0 - initialBackCylinderMaterialOpacity) * p
            },

            $progress: 1
        })        
    }

    fromRepeat2To4 = (duration = 1.2, onStart = null) => {

        // geometry position
        let position = this._cylinderGeometryPosition
        let array = this._cylinderGeometryPosition.array
        let length = this._cylinderGeometryPositionArrayLength
        let prevPositionArray = [...position.array]

        // material repeat
        let initialRepeat = this._frontCylinder.material.map.repeat.x

        // camera
        let initialCameraPositionY = this.camera.position.y

        // back cylinder material
        let initialBackCylinderMaterialOpacity = this._backCylinder.material.opacity


        let animation = {$progress: 0}

        return gsap.to(animation, {
            duration: duration,
            ease: params.Animations.easeInOut,

            onStart: () => {
                onStart && onStart()  
            },

            onUpdate: () => {

                let p = animation.$progress

                /**
                 * animate material repeat
                 */

                let newRepeat = initialRepeat + (1 - initialRepeat) * p

                this._frontCylinder.material.map.repeat.x = newRepeat
                this._backCylinder.material.map.repeat.x = newRepeat

                /**
                 * animate geometry position
                 */
                for(let i = 0; i < length; i++){
                    

                    if(i % 3 === 0 || i % 3 === 2 ){
                        let newValue = prevPositionArray[i] + (this._initialCylinderGeometryPositionArray[i] - prevPositionArray[i]) * p

                        array[i] = newValue
                        this._backCylinder.geometry.attributes.position.array[i] = newValue
                    }
                }

                position.needsUpdate = true
                this._backCylinder.geometry.attributes.position.needsUpdate = true
                
                /**
                 * animate camera
                 */
                // this.camera.position.y = initialCameraPositionY + (CAMERA_TOP_POSITION - initialCameraPositionY) * p

                /**
                 * animate back cylinder material
                 */
                this._backCylinder.material.opacity = initialBackCylinderMaterialOpacity + (2 - initialBackCylinderMaterialOpacity) * p
            },

            $progress: 1
        })        
    }

    animateLogoAppear_justRestore(){

        let duration = 1.2

        let timeline = gsap.timeline({
            onStart: () => {
                // set new logo mode
                this._logoMode = LOGO_MODE.middle

                // reset currentMouse
                this._currentMouse.set(0, 0)

                this._tiltingContainer.rotation.x = 0
                this._tiltingContainer.rotation.z = 0
            },
            onComplete: () => {

                this._canRotate = true

            }
        })

        // Mobile mode
        if(this.data.isMobile){
            timeline.to(this.container, {
                duration: duration * .5,
                ease: params.Animations.easeInOut,
                
                opacity: 1
            })
        }

        timeline.add(this.fromRepeat2To4())

        this._backCylinder.material.map.offset.x = -1
        timeline.to([this._frontCylinder.material.map.offset, this._backCylinder.material.map.offset], {
            duration: duration,
            ease: params.Animations.easeInOut,

            x: 0
        }, "<")
    }

    animateLogoAppear_startingButNotAtHome(){

        let duration = 1.2

        // no flicker
        this.scene.visible = false

        this._openingAnimationTimeline = gsap.timeline({
            onStart: () => {
                // no flicker
                this.scene.visible = true
            },
            onComplete: () => {

                // set new logo mode
                this._logoMode = LOGO_MODE.header

                // on mobile we end this later
                if(this.data.isMobile) {
                    MyEmitter.emit(params.Events.logoGoHeader, true, () => this.onLoaderEnd())
                    // this._frontCylinder.material.map.offset = this._backCylinder.material.map.offset = 0
                }

            }
        })

        this._openingAnimationTimeline.fromTo(this._frontCylinder.material.map.offset, {
            x: 1
        }, {
            duration: duration,
            ease: params.Animations.easeInOut,

            // so we can 1 repetion of 4
            x: 1 - (1 / 4) - .02
        })

        this._openingAnimationTimeline.addLabel(OPENING_ANIMATIONS_LABEL.wordAppears)

        this._openingAnimationTimeline.fromTo([this._frontCylinder.material.map.offset, this._backCylinder.material.map.offset], {
            x: 1 - (1 / 4) - .02 // related to r01
        }, {
            duration: 1.2,
            ease: params.Animations.easeInOut,
            repeat: -1,
            delay: .1,
            repeatDelay: .3,

            x: 1 - (2 / 4) - .02 // related to r01
        })
    }

    animateLogoAppear_startingButNotAtHome_open(){

        
        if(this._openingAnimationTimeline.currentLabel() === OPENING_ANIMATIONS_LABEL.wordAppears){

            this._openingAnimationTimeline.recent().repeat(0)
            
            this._backCylinder.material.map.offset.x = -1
            this._openingAnimationTimeline.to([this._frontCylinder.material.map.offset, this._backCylinder.material.map.offset], {
                duration: duration,
                ease: params.Animations.easeInOut,
    
                x: 1 - (2 / 4) - .02 // related to r01
            })

            this._openingAnimationTimeline.nextLabel()
        } else {
            let last = this._openingAnimationTimeline.recent()

            last.repeat(0)
            last.repeatDelay(0)
        }

        let duration = 1.2

        // Mobile mode
        if(this.data.isMobile){
            this._openingAnimationTimeline.to(this.container, {
                duration: duration * .5,
                ease: params.Animations.easeInOut,

                
                opacity: 0
            })

            return
        }

        this._openingAnimationTimeline.to(this.data.navItems, {
            duration: .5,
            ease: params.Animations.easeDecrement,

            opacity: 1,
            visibility: "visible"
        }, ">-.5")

        let emptyAnim = {$progress : 0}
        this._openingAnimationTimeline.to(emptyAnim, {
            duration: 0,
            onStart: () => {
                MyEmitter.emit(params.Events.logoGoHeader, true, () => this.onLoaderEnd()) // just move header up then loaderEnd
            },

            $progress: 1
        }, ">.2")
    }

    animateLogoAppear(justRestore = false){

        let startingButNotAtHome = Boolean(!justRestore && this.data.startAt !== "home")

        if(startingButNotAtHome){
            this.animateLogoAppear_startingButNotAtHome()
        }
        else if(justRestore){
            this.animateLogoAppear_justRestore()
        }
        else {

            // no flicker 
            this.scene.visible = false


            this._openingAnimationTimeline = gsap.timeline({
                onStart: () => {
                    // no flicker 
                    this.scene.visible = true
                },
                onComplete: () => {
                    // set new logo mode
                    this._logoMode = LOGO_MODE.middle
                }
            })
    
            this._openingAnimationTimeline.fromTo(this._frontCylinder.material.map.offset, {
                x: 1
            }, {
                duration: 1.2,
                ease: params.Animations.easeInOut,
    
                // so we can 1 repetion of 4
                x: 1 - (1 / 4) - .02
            })

            this._openingAnimationTimeline.addLabel(OPENING_ANIMATIONS_LABEL.wordAppears)

            this._openingAnimationTimeline.fromTo([this._frontCylinder.material.map.offset, this._backCylinder.material.map.offset], {
                x: 1 - (1 / 4) - .02 // related to r01
            }, {
                duration: 1.2,
                ease: params.Animations.easeInOut,
                repeat: -1,
                delay: .1,
                repeatDelay: .3,
    
                x: 1 - (2 / 4) - .02 // related to r01
            })
        }
    }


    animateLogoAppear_open(){

        if(this._openingAnimationTimeline.currentLabel() === OPENING_ANIMATIONS_LABEL.wordAppears){

            this._openingAnimationTimeline.recent().repeat(0)
            
            // this._backCylinder.material.map.offset.x = -1
            // this._openingAnimationTimeline.to([this._frontCylinder.material.map.offset, this._backCylinder.material.map.offset], {
            //     duration: duration,
            //     ease: params.Animations.easeInOut,
    
            //     x: 1 - (2 / 4) - .02 // related to r01
            // })

            this._openingAnimationTimeline.nextLabel()
        } else {
            let last = this._openingAnimationTimeline.recent()

            last.repeat(0)
            last.repeatDelay(0)
        }

        let duration = 1.2

        this._backCylinder.material.map.offset.x = -1
        this._openingAnimationTimeline.to([this._frontCylinder.material.map.offset, this._backCylinder.material.map.offset], {
            duration: 1.2,
            ease: params.Animations.easeInOut,

            x: 0
        }, ">.2")

        this._openingAnimationTimeline.add(this.fromRepeat2To4(1.2, () => {

            // dirty delaying
            setTimeout(() => {
                this.onLoaderEnd()
                this._canRotate = true
            }, 500)
        }), "<.6")

        this._openingAnimationTimeline.to(this.data.navItems, {
            duration: .6,
            ease: params.Animations.easeDecrement,

            opacity: 1,
            visibility: "visible"
        }, "<.7")
    }

    /** Events */

    // scale on slide slider
    onSliderSlide(scale){

        let _scale = scale
        
        if(this.data.isMobile){
            _scale = Math.max(1, scale * .9)
        }

        gsap.to(this._tiltingContainer.scale, {
            ease: params.Animations.easeDecrement,
            duration: ANIMATION_SLIDE_DURATION,
            
            x: _scale,
            y: _scale,
            z: _scale,
        })
    }

    onLoaderEnd(){
        MyEmitter.emit(params.Events.onLoaderEnd)
    }

    onMouseMove(event){

        let currentMouse = utils.getMousePosition(event)

        this._targetMouse.set(
            currentMouse[0],
            currentMouse[1]
        )
    }

    handleLeave(){
        this.stop()
    }


    onRessourcesReady(){

        console.log("AXAXAX")

        if(this.data.startAt !== "home"){
            this.animateLogoAppear_startingButNotAtHome_open()
        }
        else {
            this.animateLogoAppear_open()
        }
    }

    onMobileOrientation(){

        let beta = event.beta
        let gamma = event.gamma

        let percentGamma = utils.limit(gamma / 45, -1, 1)
        let percentBeta = utils.limit((beta - 90) / 22.5, -1, 1)

        this._targetMouse.set(
            percentGamma,
            percentBeta,
        )
    }

    attachEvents(){
        super.attachEvents()

        // desktop events
        if(!this.data.isMobile){
            window.addEventListener("mousemove", this.onMouseMove)
        } 
        // mobile events
        else {
            window.addEventListener("deviceorientation", this.onMobileOrientation, true)
        }

    }

    removeEvents(){
        super.removeEvents()

        // desktop events
        if(!this.data.isMobile){
            window.removeEventListener("mousemove", this.onMouseMove)
        }
        // mobile events
        else {
            window.removeEventListener("deviceorientation", this.onMobileOrientation, true)
        }
    }
}